export const truncate = (
  text: string,
  maxLength: number = 150,
  suffix: string = '...',
): string => {
  if (!text || text.length <= maxLength) {
    return text || '';
  }
  
  // Find the last space before the max length to avoid cutting words
  const truncated = text.substring(0, maxLength);
  const lastSpaceIndex = truncated.lastIndexOf(' ');
  
  // If we found a space and it's not too close to the beginning, cut there
  if (lastSpaceIndex > maxLength * 0.8) {
    return truncated.substring(0, lastSpaceIndex) + suffix;
  }
  
  // Otherwise, just cut at the max length
  return truncated + suffix;
};